<template>
  <header>
    <BContainer fluid>
      <BRow class="align-items-center bildschirmansicht">
        <BCol md="4">
          <router-link to="/" class="nav-link">
            <img src="../assets/Logo.jpg" class="HeaderLogo" alt="LogoLTB" />
            
          </router-link>
        </BCol>
        <BCol md="6">
          <nav class="navbar navbar-expand-lg text-uppercase">
            <ul class="navbar-nav fw-bold">
              <li class="nav-item ps-5">
                <router-link to="/" class="nav-link">
                  <i class="fas fa-home headerIcon text-danger "></i><br />{{ $t("home") }}
                </router-link>
              </li>
              <li class="nav-item px-5">
                <router-link to="/Leistungen" class="nav-link">
                  <i class="fas fa-chart-line headerIcon text-danger"></i><br />{{ $t("leistungen") }}
                </router-link>
              </li>
              <li class="nav-item px-5">
                <router-link to="/Referenzen" class="nav-link">
                  <i class="fas fa-file-invoice headerIcon text-danger"></i><br />{{
                    $t("referenzen")
                  }}
                </router-link>
              </li>

              <li class="nav-item px-5">
                <router-link to="/Kontakt" class="nav-link">
                  <i class="far fa-envelope-open headerIcon text-danger"></i><br />{{ $t("contact") }}
                </router-link>
              </li>
            </ul>
          </nav>
        </BCol>
        <!-- <BCol md="2" class="text-end">
          <button @click="changeLanguage('en')" class="languageNav  ">
            <img src="../assets/united-kingdom.png" class="languageIcon" alt="LogoLTB" />
          </button>
          <button @click="changeLanguage('de')" class="languageNav  ">
            <img src="../assets/germany.png" class="languageIcon" alt="LogoLTB" />
          </button>
        </BCol> -->
      </BRow>
      <BRow class="handyansicht">
        <BCol md="4" cols="10">
          <router-link to="/" class="nav-link">
            <img src="../assets/Logo.jpg" class="HeaderLogo" alt="LogoLTB" />            
          </router-link>
        </BCol>

        <BCol md="8" cols="2">
          <div class="hamburger-menu text-end" @click="toggleMenu">
            <i class="fas fa-bars"></i>
          </div>
          
        </BCol>
      </BRow>
      <BRow>
        <BCol>
          <hr />
        </BCol>
      </BRow>

      <BRow>
        <BCol>
            <div v-if="menuOpen" class="mobile-menu handyansicht">
                <ul class="navbar-nav fw-bold">
                  <li class="nav-item">
                    <router-link to="/" class="nav-link text-uppercase" @click="toggleMenu">
                      <i class="fas fa-home headerIconMobil"></i>&nbsp;{{ $t("home") }}
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/leistungen" class="nav-link" @click="toggleMenu">
                      <i class="fas fa-file-invoice"></i>&nbsp;{{ $t("leistungen") }}
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/referenzen" class="nav-link" @click="toggleMenu">
                      <i class="fas fa-file-invoice"></i>&nbsp;{{ $t("referenzen") }}
                    </router-link>
                  </li>
    
                  <li class="nav-item">
                    <router-link to="/Kontakt" class="nav-link" @click="toggleMenu">
                      <i class="far fa-envelope-open"></i>&nbsp;{{ $t("contact") }}
                    </router-link>
                  </li>
                </ul>
              </div>
        </BCol>
      </BRow>
    </BContainer>
  </header>
</template>

<script>
export default {
  name: "AppHeader",
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang;
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
  },
  data() {
    return {
      menuOpen: false,
    };
  },
};
</script>
